module.exports = __webpack_public_path__ + "images/Group 1259090434e828dded1cfe9607e721ff3276.svg";